<template>
  <div class="privacy">
      <h1>プライバシーポリシー</h1>
        <h2>当サイトに掲載されている広告について</h2>
        <p>当サイトでは、第三者配信の広告サービス（Googleアドセンス、A8.net、Amazonアソシエイト）を利用しています。</p>
        <p>このような広告配信事業者は、ユーザーの興味に応じた商品やサービスの広告を表示するため、当サイトや他サイトへのアクセスに関する情報 『Cookie』(氏名、住所、メール アドレス、電話番号は含まれません) を使用することがあります。</p>
        <h2>当サイトが使用しているアクセス解析ツールについて</h2>
        <p>当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。</p>
        <p>このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。</p>
        <p>このトラフィックデータは匿名で収集されており、個人を特定するものではありません。</p>
        <p>この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.privacy{
  padding: 10px;
}
h1{
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  padding-bottom: 20px;
}
h2{
  font-weight: bold;
  padding-top: 10px; 
  padding-bottom: 10px;
}
</style>